var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgloo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 33.875C309.5 32.75 298.75 32 288 32C188.25 32 100.25 82.75 48.625 160H320V33.875ZM352 39.375V160H527.375C487.25 99.875 424.75 55.875 352 39.375ZM480 320H576C576 274 564.875 230.625 545.75 192H480V320ZM96 192H30.25C11.125 230.625 0 274 0 320H96V192ZM400 320H448V192H128V320H176V352H0V432C0 458.51 21.49 480 48 480H208L208 340.56C208 298.713 238.111 260.581 279.75 256.414C327.637 251.621 368 289.096 368 336V480H528C554.51 480 576 458.51 576 432V352H400V320Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgloo);
export default __webpack_public_path__ + "static/media/igloo.fae80c7ea75709b473880b1cdf4bd6b0.svg";
export { ForwardRef as ReactComponent };